/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol extends models.ServiceAccountCredentialsBaseForGcpServiceAccountProtocol {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol>): ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol(), model);
        ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol>): ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol.newInstance(<ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForGcpServiceAccountProtocol.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForGcpParentBillingAccountServiceAccountProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Project Id in which the billing bucket exists. This is a required field.
     */
    project_id: string;

    /**
     * Bucket Name. This is a required field.
     */
    bucket_name: string;

    /**
     * DataSet Id. This is a required field.
     */
    data_set_id: string;

}
